// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { CommercialAgreementOffer } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Offer';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';

export const useCancelCommercialAgreementOffer: () => UseMutationResult<
  void,
  string,
  {
    commercialAgreementCid: ContractId<CommercialAgreementOffer>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['cancelCommercialAgreementOffer', ledgerApi],
    mutationFn: async ({ commercialAgreementCid }) => {
      await ledgerApi.cancelCommercialAgreementOffer(commercialAgreementCid);
    },
  });
};
